/**
 * @author Ivan Toth.
 */
var DetailEligibilityEditController = (function () {
    function DetailEligibilityEditController(topic, $state, $stateParams) {
        this.topic = topic;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.OPP_VERSION_2 = 2;
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_5 = 5;
    }
    ;
    DetailEligibilityEditController.prototype.$onInit = function () {
        this.fieldStyle = { color: 'red' };
    };
    DetailEligibilityEditController.prototype.goto = function (tab) {
        this.$state.go(tab.name, this.$stateParams);
        this.activeTab = tab.name;
    };
    // Attach file attachemnts
    DetailEligibilityEditController.prototype.attachFile = function () {
        alert('Attaching a file');
    };
    DetailEligibilityEditController.$inject = ['topic', '$state', '$stateParams'];
    return DetailEligibilityEditController;
}());
var DetailEligibilityEditComponent = (function () {
    function DetailEligibilityEditComponent() {
        this.templateUrl = 'detail-eligibility.html';
        this.controllerAs = 'vm';
        this.controller = DetailEligibilityEditController;
    }
    return DetailEligibilityEditComponent;
}());
angular
    .module('application')
    .component('detailEligibilityEdit', new DetailEligibilityEditComponent());

//# sourceMappingURL=detail.eligibility.edit.component.js.map
